import type {
  DocumentExtension,
  DocumentExtractionStatus,
  DocumentExtraction,
  DocumentType,
  SmartSummary,
  UserDocumentWithId,
} from "@/shared/types/documentTypes";

export interface DocumentViewMetadata {
  id: number;
  extractionStatus: string;
  documentType: DocumentType;
  fileName: string;
  displayName: string | null;
  smartSummary: SmartSummary | null;
  documentExtraction: DocumentExtraction | null;
  specificDocExtraction: Record<string, unknown> | null;
  specificDocCitations: Record<string, unknown> | null;
  createdAt: string;
}

export function getDocumentExtension(fileName: string): DocumentExtension {
  const extension = fileName.split(".").pop()?.toLowerCase();

  switch (extension) {
    case "pdf":
      return "application/pdf";
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    default:
      return "other";
  }
}

export function buildUserDocument(
  metadata: DocumentViewMetadata,
  previewUrl?: string,
): UserDocumentWithId {
  return {
    id: metadata.id,
    name: metadata.fileName,
    documentType: metadata.documentType,
    extractionStatus: metadata.extractionStatus as DocumentExtractionStatus,
    fileName: metadata.fileName,
    fileSize: 0,
    createdAt: metadata.createdAt,
    updatedAt: metadata.createdAt,
    extension: getDocumentExtension(metadata.fileName),
    previewUrl,
    display_name: metadata.displayName,
    smart_summary: metadata.smartSummary,
    document_extraction: metadata.documentExtraction,
    specific_doc_extraction: metadata.specificDocExtraction,
    specific_doc_citations: metadata.specificDocCitations,
  };
}

export const isExtractionReadable = (
  summaryStatus: string | undefined,
  hasSpecificData: boolean,
): boolean => (summaryStatus === "completed" || summaryStatus === "failed") && hasSpecificData;
